import { Span } from "@tblabs/truffle";
import { Table } from "@tblabs/truffle/Controls/TableBuilder/Table";
import { PaymentForm, PaymentFormNames } from "../../../Models/Payment/PaymentForm";
import { PaymentStepData } from "../Models/PaymentStepData";
import { Human } from "../../../Models/Human";


export class PaymentInfoForAdmin extends Table
{
    constructor(payment: PaymentStepData, people: Human)
    {
        super();

        this.Class("payment-info-table");

        this.AddRow("Forma", PaymentFormNames[payment.Form.value])
            .AddRow("Kwota", new Span(payment.AmountAsString).Attribute("data-testid", "payment-info-amount"))
            .AddRow("Nadawca", people.Name.value)
            .AddRow("Tytułem", payment.Title.value)

        switch (payment.Form.value)
        {
            case PaymentForm.BankTransfer:
                // this.AddRow("Z konta", people.BankAccountNumber.value)
                break;

            case PaymentForm.Blik:
                this.AddRow("Z numeru", people.Phone.value)
                break;

            case PaymentForm.Crypto:
                const btcAmount = (payment.Amount.value / payment.ExchangeRate.value).toFixed(8);
                this.AddRow("Do przelania", new Span(btcAmount + " " + payment.PaymentCurrency.value).Bold())
                    .AddRow("Kurs BTC", payment.ExchangeRate.value.toString() + " PLN za 1 BTC")
                break;

            default:
            case PaymentForm.Cash:
                break;
        }
    }
}
